var styles = {"Disclaimer":"styles-module_Disclaimer__O25l3","PrivacyLink":"styles-module_PrivacyLink__DaCE2"};

export { styles as default };
